import { useState, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { errText } from "../lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setStatus("error"); setMessage("Link non valido."); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/change-email/confirm", { token });
        setEmail(data.email || "");
        setStatus("success");
      } catch (err) {
        setStatus("error");
        setMessage(errText(err.response?.data?.detail) || "Verifica non riuscita.");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FAF8F5]">
      <div className="w-full max-w-sm text-center eq-fade-up" data-testid="verify-email-page">
        <div className="flex items-center justify-center gap-2 mb-8">
          <img src="/icon-192.png" alt="Equiro" className="h-11 w-11 rounded-xl object-cover" />
          <span className="font-display font-extrabold text-2xl text-[#1B3B2B]">Equiro</span>
        </div>

        {status === "loading" && (
          <div data-testid="verify-loading">
            <Loader2 className="h-12 w-12 text-[#1B3B2B] mx-auto mb-4 animate-spin" />
            <p className="text-[#5F6B64]">Verifica in corso…</p>
          </div>
        )}
        {status === "success" && (
          <div data-testid="verify-success">
            <CheckCircle2 className="h-12 w-12 text-[#1B3B2B] mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold text-[#1B3B2B]">Email confermata</h1>
            <p className="text-[#5F6B64] mt-2">
              Il tuo nuovo indirizzo di accesso {email ? <strong>{email}</strong> : ""} è attivo. Usalo al prossimo accesso.
            </p>
            <Link to="/login" className="inline-block mt-6 text-[#8C532B] font-semibold" data-testid="verify-to-login">Vai all'accesso</Link>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-error">
            <XCircle className="h-12 w-12 text-red-600 mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold text-[#1B3B2B]">Verifica non riuscita</h1>
            <p className="text-[#5F6B64] mt-2">{message}</p>
            <Link to="/account" className="inline-block mt-6 text-[#8C532B] font-semibold" data-testid="verify-to-account">Torna all'account</Link>
          </div>
        )}
      </div>
    </div>
  );
}
